/* tslint:disable */
/* eslint-disable */
/**
 * Befunde API
 * Internal API of befunde-ui for searching and downloading Befunde and for managing accounts, users and themes. The lab-transmitter uploads Befunde through it as well.
 *
 * The version of the OpenAPI document: 0.0.0
 * Contact: support@medcom.at
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { RestError } from '../model';
/**
 * MyContextApi - axios parameter creator
 * @export
 */
export const MyContextApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lists the LabId:Identifier pairs the current user may see Befunde for.
         * @summary List of all LabId:Identifier of current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyLabIdentifiers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/my-lab-identifiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MyContextApi - functional programming interface
 * @export
 */
export const MyContextApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MyContextApiAxiosParamCreator(configuration)
    return {
        /**
         * Lists the LabId:Identifier pairs the current user may see Befunde for.
         * @summary List of all LabId:Identifier of current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyLabIdentifiers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyLabIdentifiers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MyContextApi.getMyLabIdentifiers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MyContextApi - factory interface
 * @export
 */
export const MyContextApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MyContextApiFp(configuration)
    return {
        /**
         * Lists the LabId:Identifier pairs the current user may see Befunde for.
         * @summary List of all LabId:Identifier of current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyLabIdentifiers(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getMyLabIdentifiers(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MyContextApi - object-oriented interface
 * @export
 * @class MyContextApi
 * @extends {BaseAPI}
 */
export class MyContextApi extends BaseAPI {
    /**
     * Lists the LabId:Identifier pairs the current user may see Befunde for.
     * @summary List of all LabId:Identifier of current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyContextApi
     */
    public getMyLabIdentifiers(options?: RawAxiosRequestConfig) {
        return MyContextApiFp(this.configuration).getMyLabIdentifiers(options).then((request) => request(this.axios, this.basePath));
    }
}

